<template>
  <section
    :class="Object.keys(this.userData).length == 0 && 'container '"
    :style="[
      Object.keys(this.userData).length == 0 && { 'max-width': '1185px' },
    ]"
  >
    <auth-header v-if="Object.keys(this.userData).length == 0" />
    <b-row class="flex-wrap px-50">
      <b-col lg="8" class="d-flex px-50">
        <competition-detail
          @showShareButtons="showShareButtons = true"
          @rulesShow="showRules()"
          @register="register"
          class="w-100"
          :competition="competition"
          :loading="loading"
          @showPayModal="
            payItem = $event;
            showPayModal = true;
          "
          @showChangeStatusModal="
            changeStatusItem = $event;
            showChangeStatusModal = true;
          "
        />
      </b-col>
      <b-col lg="4" class="d-flex px-50">
        <competition-holder class="w-100" :loading="loading" :holder="holder" />
      </b-col>
      <b-col cols="12" class="d-flex px-50 w-100">
        <!-- <competition-tabs :competition="competition" /> -->

        <b-card class="w-100">
          <div
            class="w-100 d-flex align-items-center justify-content-between flex-wrap"
          >
            <div
              class="w-100 filters rounded p-md-2 p-50 my-1 d-flex align-items-center flex-wrap"
            >
              <div class="p-50 col-md-3 col-6">
                <b-button
                  @click="show = 'participants'"
                  :class="['w-100', show == 'participants' && 'gradient-btn']"
                  type="button"
                >
                  <span class="h5"> Participants</span>
                </b-button>
              </div>
              <div class="p-50 col-md-3 col-6" v-if="competition.active">
                <b-button
                  @click="show = 'trades'"
                  :class="['w-100', show == 'trades' && 'gradient-btn']"
                  type="button"
                >
                  <span class="h5"> Open Trades</span>
                </b-button>
              </div>
              <div class="p-50 col-md-3 col-6" v-if="1">
                <b-button
                  @click="show = 'Rules'"
                  :class="['w-100', show == 'Rules' && 'gradient-btn']"
                  type="button"
                >
                  <span class="h5"> Rules</span>
                </b-button>
              </div>
              <div class="p-50 col-md-3 col-6" v-if="1">
                <b-button
                  @click="show = 'terms'"
                  :class="['w-100', show == 'terms' && 'gradient-btn']"
                  type="button"
                >
                  <span class="h5"> Terms and conditions</span>
                </b-button>
              </div>
              <!-- <b-form class="p-50 col-md-10 col-8">
                <b-form-input placeholder="search" />
              </b-form>
              <div class="p-50 col-md-2 col-4">
                <b-button class="w-100" type="submit">
                  <span class="text-muted h5"> Filtering</span>
                </b-button>
              </div> -->
            </div>
          </div>
          <participants-table class="w-100" v-if="show == 'participants'" />
          <div v-else-if="show == 'trades'">
            <div
              class="filters p-2 d-flex justify-content-center text-align-center rounded"
              v-if="calRemaining(competition).status === 'danger'"
            >
              <h6>This competition is not Running.</h6>
            </div>

            <open-trades v-else-if="competition.active" class="w-100" />
          </div>

          <div v-else-if="show == 'Rules'" class="Rules">
            <b-card>
              <div
                class="font-wegiht-bold mb-2 px-1"
                v-if="
                  competition.draw_down_value != null &&
                  Number(competition.draw_down_weight) != 3
                "
              >
                <span class="text-bold"> - Drawdown percentage: </span
                ><span class="text-success">
                  {{
                    competition.draw_down_value
                      ? parseFloat(Number(competition.draw_down_value)) + "%"
                      : "0"
                  }}</span
                >
              </div>
              <div
                class="font-wegiht-bold mb-2 px-1"
                v-if="
                  competition.starting_balance_value != null &&
                  Number(competition.starting_balance_weight) != 3
                "
              >
                <span class="text-bold"> - Starting balance: </span
                ><span class="text-success">
                  {{
                    competition.starting_balance_value
                      ? "$" + competition.starting_balance_value
                      : "0"
                  }}</span
                >
              </div>
              <div
                class="font-wegiht-bold mb-2 px-1"
                v-if="
                  competition.minimum_trade_value != null &&
                  Number(competition.minimum_trade_weight) != 3
                "
              >
                <span class="text-bold"> - Minimum number of trades: </span>

                <span class="text-success">
                  {{
                    competition.minimum_trade_value
                      ? competition.minimum_trade_value
                      : "0"
                  }}</span
                >
              </div>
            </b-card>
          </div>
          <div v-else-if="show == 'terms'">
            <b-card>
              <div
                v-if="
                  hasOwnNestedProperty(competition, 'conditions.length') &&
                  competition.conditions.length
                "
              >
                <div
                  class="font-wegiht-bold mb-2 px-1"
                  v-for="(condition, index) in competition.conditions"
                  :key="index"
                >
                  {{ index + 1 + ". " + condition || "-" }}
                </div>
              </div>
              <div v-else>
                <div
                  class="d-flex align-items-center justify-content-center h-100 new-alert"
                >
                  <b-alert
                    show
                    variant="secondary"
                    class="d-flex align-items-center justify-content-center p-3 w-100"
                  >
                    no information
                  </b-alert>
                </div>
              </div>
            </b-card>
          </div>
        </b-card>

        <competition-register
          :visible="visible"
          v-model="visible"
          :competition="competition"
        />
      </b-col>
      <b-col
        md="4"
        cols="12"
        class="d-flex px-50"
        v-for="(befnifit, index) in befnifits"
        :key="index"
      >
        <competition-benefit-box class="w-100" :info="befnifit" />
      </b-col>
    </b-row>
    <pay-modal
      payType="register"
      :item="payItem"
      :visible="showPayModal"
      v-model="showPayModal"
    />
    <change-status-modal
      :item="changeStatusItem"
      :visible="showChangeStatusModal"
      v-model="showChangeStatusModal"
      @updateCompetitions="getCompetition"
    />
    <share-buttons :visible="showShareButtons" v-model="showShareButtons" />
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormInput,
  BAlert,
  BNavbar,
  BNavbarNav,
  BImg,
} from "bootstrap-vue";
import CompetitionNav from "./CompetitionNav.vue";
import CompetitionDetail from "./CompetitionDetail.vue";
import CompetitionHolder from "./CompetitionHolder.vue";
import CompetitionBenefitBox from "./CompetitionBenefitBox.vue";
import CompetitionTabs from "./competition-tabs/CompetitionTabs.vue";
import CompetitionRegister from "./competition-register/CompetitionRegister.vue";
import ChangeStatusModal from "../ChangeStatusModal.vue";
import PayModal from "../PayModal.vue";
import ShareButtons from "./ShareButtons.vue";
import AuthHeader from "@/views/panel/auth/auth-header/AuthHeader";
import ParticipantsTable from "@/views/panel/competitions/competition-live/ParticipantsTable.vue";
import OpenTrades from "@/views/panel/competitions/competition-live/OpenTrades.vue";
export default {
  components: {
    BRow,
    BCard,
    BButton,
    BForm,
    BFormInput,
    BAlert,
    BCol,
    BNavbar,
    BNavbarNav,
    BImg,
    CompetitionNav,
    CompetitionDetail,
    CompetitionHolder,
    CompetitionBenefitBox,
    CompetitionTabs,
    CompetitionRegister,
    ChangeStatusModal,
    PayModal,
    ParticipantsTable,
    OpenTrades,
    AuthHeader,
    ShareButtons,
  },
  data() {
    return {
      analytics: {},

      show: "participants",
      payItem: {},
      visible: false,
      loading: false,
      competition: {},
      changeStatusItem: {},
      showPayModal: false,
      showChangeStatusModal: false,
      showShareButtons: false,
      holder: {},
      befnifits: [
        {
          img: "winner-certificate.svg",
          title: "Winner certificate",
          description:
            "All the winners will receive a valid winner certificate along with the allocated awards.",
        },
        {
          img: "prize-distribution-time.svg",
          title: "Prize distribution time",
          description:
            "The prizeds will distributed amongst all the winners upon the expiration of the competition.",
        },
        {
          img: "guaranteed-prize.svg",
          title: "Guaranteed prize allocation",
          description:
            "We guarantee that the prizes will be distributed to the winners after they are approved by the competiion holder.",
        },
      ],
    };
  },
  computed: {
    // rules() {
    //   return [
    //     {
    //       title: "Drawdown percentage:",
    //       draw_down_weight: this.competition.draw_down_weight,
    //       draw_down_value: this.competition.draw_down_value,
    //     },
    //     {
    //       title: "Starting balance:",
    //       starting_balance_weight: this.competition.starting_balance_weight,
    //       starting_balance_value: this.competition.starting_balance_value,
    //     },
    //     {
    //       title: "Minimum number of trades:",
    //       minimum_trade_weight: this.competition.minimum_trade_weight,
    //       minimum_trade_value: this.competition.minimum_trade_value,
    //     },
    //   ];
    // },
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
  watch: {
    show(val) {
      let remaining = this.calRemaining(this.competition);
      if (
        val == "trades" &&
        Object.keys(this.userData).length == 0 &&
        (remaining.status == "yellow" || remaining.status == "warning")
      ) {
        this.$swal({
          icon: "warning",
          title: "The competition has not started yet!",
        });
      }
    },
    visible: {
      handler(val) {
        if (!val) {
          localStorage.removeItem("wantToRegister");
        }
      },
    },
  },
  methods: {
    showRules() {
      this.show = "Rules";
      setTimeout(() => {
        var element = document.querySelector(".Rules");
        var top = element.scrollHeight;
        window.scrollTo({ top: 600, behavior: "smooth" });
      }, 200);
    },
    register() {
      if (Object.keys(this.userData).length) {
        this.visible = true;
        localStorage.removeItem("wantToRegister");
      } else {
        localStorage.setItem("wantToRegister", this.$route.params.id);
        this.$router.push({ name: "auth-user-register" });
      }
    },

    async getCompetition() {
      try {
        const { data } = await this.$http.get(
          Object.keys(this.userData).length
            ? `/panel/competitions/${this.$route.params.id}`
            : `/competitions/${this.$route.params.id}`,
          {
            params: {
              include: ["brokers"],
            },
          }
        );
        this.competition = data.data;
      } catch (error) {}
    },
    async getHolder() {
      try {
        const { data } = await this.$http.get(
          Object.keys(this.userData).length
            ? `/panel/competitions/${this.$route.params.id}/partner`
            : `/competitions/${this.$route.params.id}/partner`
        );
        this.holder = data.data;
      } catch (error) {}
    },
  },
  async created() {
    this.loading = true;
    await this.getCompetition();
    await this.getHolder();
    let wantToRegister = await localStorage.getItem("wantToRegister");
    if (
      wantToRegister &&
      this.$route.params.id == wantToRegister &&
      Object.keys(this.userData).length
    ) {
      this.visible = true;
    }
    this.loading = false;
  },
};
</script>

<style></style>
